import { render } from "./KskButton.vue?vue&type=template&id=1e598586&scoped=true"
import script from "./KskButton.vue?vue&type=script&lang=js"
export * from "./KskButton.vue?vue&type=script&lang=js"

import "./KskButton.vue?vue&type=style&index=0&id=1e598586&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e598586"]])

export default __exports__